import { Omit } from '@material-ui/types';
import { FormikConfig, FormikProvider, useFormik } from 'formik';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Schema } from 'yup';

import { SchemaProvider } from './Schema';

const Container = styled.form`
  flex: 1;
`;

type Props<T = any> = Omit<FormikConfig<T>, 'validationSchema'> & {
  // Force missing typings for the schema
  validationSchema: Schema<T>;
};

export default function Form({
  children,
  initialValues,
  validationSchema: schema,
  ...props
}: Props) {
  const values = useMemo(
    () => schema.cast(initialValues, { stripUnknown: true }),
    [initialValues, schema]
  );

  const form = useFormik({
    initialValues: values,
    enableReinitialize: true,
    validationSchema: schema,
    ...props
  });

  return (
    <FormikProvider value={form}>
      <SchemaProvider value={schema}>
        <Container onSubmit={form.handleSubmit}>{children}</Container>
      </SchemaProvider>
    </FormikProvider>
  );
}
